export default __webpack_public_path__ + "static/media/points-to-consider-before-buying-a-term-insurance-policy.4e574585.jpg";